<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="是否限时" prop="isLimitedTime" >
        <a-radio-group name="radioGroup" v-model="form.isLimitedTime">
          <a-radio :value="false">否</a-radio>
          <a-radio :value="true">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="是否限一次" prop="isLimitedToOnce" >
        <a-radio-group name="radioGroup" v-model="form.isLimitedToOnce">
          <a-radio :value="false">否</a-radio>
          <a-radio :value="true">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="限时起始时间" prop="limitStartTime" v-if="form.isLimitedTime || form.isLimitedToOnce">
        <a-date-picker
          style="width: 100%"
          v-model="form.limitStartTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear />
      </a-form-model-item>
      <a-form-model-item label="限时截止时间" prop="limitEndTime" v-if="form.isLimitedTime || form.isLimitedToOnce">
        <a-date-picker
          style="width: 100%"
          v-model="form.limitEndTime"
          :showTime="true"
          format="YYYY-MM-DD HH:mm:ss"
          valueFormat="YYYY-MM-DD HH:mm:ss"
          allow-clear />
      </a-form-model-item>
      <a-form-model-item label="充值金额" prop="prices" >
        <a-input-number v-model="form.prices" :min="0" :step="1" :precision="0" placeholder="请输入充值金额" />
      </a-form-model-item>
      <a-form-model-item label="赠送元宝" prop="ingot" >
        <a-input-number v-model="form.ingot" :min="0" :step="1" :precision="0" placeholder="请输入赠送元宝" />
      </a-form-model-item>
      <a-form-model-item label="顺序" prop="sort" >
        <a-input-number v-model="form.sort" :min="0" :step="1" :precision="0" placeholder="请输入顺序" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-radio-group name="radioGroup" v-model="form.status">
          <a-radio :value="0">禁用</a-radio>
          <a-radio :value="1">启用</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getIngotConfig, addIngotConfig, updateIngotConfig } from '@/api/played/ingotConfig'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        isLimitedTime: undefined,
        isLimitedToOnce: undefined,
        limitStartTime: undefined,
        limitEndTime: undefined,
        prices: undefined,
        ingot: undefined,
        status: undefined,
        sort: undefined,
        remark: undefined
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        isLimitedTime: [
          { required: true, message: '是否限时不能为空', trigger: ['blur', 'change'] }
        ],
        isLimitedToOnce: [
          { required: true, message: '是否限一次不能为空', trigger: ['blur', 'change'] }
        ],
        limitStartTime: [
          { required: true, message: '限时起始时间不能为空', trigger: ['blur', 'change'] }
        ],
        limitEndTime: [
          { required: true, message: '限时截止时间不能为空', trigger: ['blur', 'change'] }
        ],
        prices: [
          { required: true, message: '充值金额不能为空', trigger: ['blur', 'change'] }
        ],
        ingot: [
          { required: true, message: '赠送元宝不能为空', trigger: ['blur', 'change'] }
        ],
        status: [
          { required: true, message: '状态不能为空', trigger: ['blur', 'change'] }
        ],
        sort: [
          { required: true, message: '顺序不能为空', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        isLimitedTime: false,
        isLimitedToOnce: false,
        limitStartTime: undefined,
        limitEndTime: undefined,
        prices: undefined,
        ingot: undefined,
        status: 1,
        sort: undefined,
        remark: undefined
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '新增元宝充值配置'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getIngotConfig(id).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改元宝充值配置'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateIngotConfig(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addIngotConfig(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
